var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill fill-height"},[_c('table-uba',{attrs:{"items":_vm.items,"hasRemoveAction":_vm.hasRemoveAction,"showCategory":_vm.showCategory}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }